let canvas
let ctx

const defaultColors = [
  { offset: 0, hex: "#ef9fcc" },
  { offset: 0.5, hex: "#e0a1a3" },
  { offset: 1, hex: "#f58556" },
]

const initCanvas = function () {
  canvas = canvas || document.createElement("canvas")
  canvas.width = 100
  canvas.height = 1
  ctx = canvas.getContext("2d", { willReadFrequently: true })
}

const rgbToHex = function (r, g, b) {
  if (r > 255 || g > 255 || b > 255) throw "Invalid color component"
  return ((r << 16) | (g << 8) | b).toString(16)
}

const drawGradient = function (colors = defaultColors) {
  const gradient = ctx.createLinearGradient(0, 0, 100, 0)
  for (const color of colors) {
    gradient.addColorStop(color.offset, color.hex)
  }
  ctx.fillStyle = gradient
  ctx.fillRect(0, 0, 100, 1)
}

const getParts = (numParts) => {
  const parts = []

  for (let i = 0; i < numParts; i++) {
    const from = Math.floor((i / numParts) * 99)
    const to = Math.floor(((i + 1) / numParts) * 99)

    const fromData = ctx.getImageData(from, 0, 1, 1).data
    const toData = ctx.getImageData(to, 0, 1, 1).data

    const fromHex =
      "#" +
      ("000000" + rgbToHex(fromData[0], fromData[1], fromData[2])).slice(-6)
    const toHex =
      "#" + ("000000" + rgbToHex(toData[0], toData[1], toData[2])).slice(-6)

    // console.log(i, from, to, fromHex, toHex)

    parts.push([fromHex, toHex])
  }

  return parts
}

export const useGradientParts = ({ numParts = 1, colors = defaultColors }) => {
  watch(
    () => colors,
    () => {
      drawGradient(colors)
    }
  )

  const parts = ref(null)
  watch(
    () => numParts.value,
    () => {
      parts.value = getParts(numParts.value)
    }
  )

  onMounted(() => {
    initCanvas()
    drawGradient(colors)
    parts.value = getParts(numParts.value)
  })

  return parts
}

export default useGradientParts
